/**
 * Returns true if `array` exists and is not empty.
 */
export const isNonEmptyArray = (array) => {
    return !!(array === null || array === void 0 ? void 0 : array.length);
};
//# sourceMappingURL=is-non-empty-array.js.map